<script lang="ts">
    export let label: string;
</script>

<div class="flex text-xxs uppercase text-white/50 px-2 pb-0.5 pt-2 relative bold">
    {label}
</div>
